<template>
  <div>
    <table
      class="table table-striped"
      v-if="TrackingData != undefined"
      style="text-align: left"
    >
      <thead class="thead-light">
        <tr>
          <th width="35%"></th>
          <th v-for="(i, index) in headers" :key="index">
            {{ i }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            Total New Orders From {{ TimeRange[0] }} To {{ TimeRange[1] }}
          </td>
          <td v-for="(i, index) in totalOrder" :key="index">
            {{ i }}
          </td>
        </tr>
        <tr>
          <td>
            Total Tracking Updated From {{ TimeRange[0] }} To {{ TimeRange[1] }}
          </td>
          <td v-for="(i, index) in totalUpdate" :key="index">
            {{ i }}
          </td>
        </tr>
        <tr>
          <td>
            Total Orders From {{ TimeRange[0] }} To {{ TimeRange[1] }} Missing
            Tracking
          </td>
          <td v-for="(i, index) in totalMissingThisWeek" :key="index">
            {{ i }}
          </td>
        </tr>
        <tr>
          <td>Total Orders Before {{ TimeRange[0] }} Missing Tracking</td>
          <td v-for="(i, index) in totalMissingLastWeek" :key="index">
            {{ i }}
          </td>
        </tr>
        <tr>
          <td>Total Orders Missing Tracking</td>
          <td v-for="(i, index) in totalTrackingMissng" :key="index">
            {{ i }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "TrackingTracking",
  props: {
    TrackingData: Object,
    TimeRange: Array,
  },
  data: () => ({
    headers: [],
    totalOrder: [],
    totalUpdate: [],
    totalMissingThisWeek: [],
    totalMissingLastWeek: [],
    totalTrackingMissng: [],
  }),
  methods: {
    loadData() {
      for (const i in this.TrackingData) {
        this.headers.push(i);
        this.totalOrder.push(this.TrackingData[i].TotalOrderInThisWeek);
        this.totalUpdate.push(
          this.TrackingData[i].TotalTrackingUpdatedInThisWeek
        );
        this.totalMissingThisWeek.push(
          this.TrackingData[i].TotalTrackingMissingInThisWeek
        );
        this.totalMissingLastWeek.push(
          this.TrackingData[i].TotalTrackingMissingSinceLastWeek
        );
        this.totalTrackingMissng.push(
          this.TrackingData[i].TotalTrackingMissing
        );
      }

      // console.log("Header",this.headers)
      // console.log("totalOrder",this.totalOrder)
      // console.log("totalUpdate",this.totalUpdate)
      // console.log("totalMissingThisWeek",this.totalMissingThisWeek)
      // console.log("totalMissingLastWeek",this.totalMissingLastWeek)
      // console.log("totalTrackingMissng",this.totalTrackingMissng)
    },
  },
  mounted() {
    console.log(this.TrackingData);
    this.TimeRange[0] = moment(this.TimeRange[0]).format("DD/MM/YYYY");
    this.TimeRange[1] = moment(this.TimeRange[1]).format("DD/MM/YYYY");
    this.loadData();
  },
};
</script>

<style scoped>
</style>